;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('headerSearch', headerSearch)

  /* @ngInject */
  function headerSearch () {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: '/core/directives/header-search/header-search-directive.html?$$REVISION$$',
      controller: 'HeaderSearchController'
    }
  }
})()
